'use client';
import { FileDropOverlayContext } from '#pplx/frontend/composer-sdk/internal/file-drop/FileDropCapabilityHost.js';
import { useContext } from 'react';
export function useFileDropOverlay() {
    const contextValue = useContext(FileDropOverlayContext);
    if (contextValue === null) {
        throw new Error('useFileDropOverlay() must be called inside <FileDropCapabilityHost>.');
    }
    return contextValue.overlay;
}
//# sourceMappingURL=FileDropCapabilityHostSupport.js.map